module.exports = __webpack_public_path__ + "static/media/Story_1_Card_Hover.9d48757e.png";